module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "deda"
  }, [_c('a', {
    attrs: {
      "id": "ded1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("“Nothing fixes a thing so intensely in the memory as the wish to forget it.”")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "rightq"
  }, [_vm._v("—Michel de Montaigne, February 28,1533–September 13, 1592")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ead3ede","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ded1.vue
// module id = 81
// module chunks = 0